import { globalVariables } from "helper/globalVariables";
import {
  barChart,
  clock,
  currencyDollar,
  hammer,
  calendar,
  link,
  star,
} from "helper/icons";
import { filterUniqueLevels } from "helper/utils";
import { useState } from "react";


export const TrailSubDetail = ({
  name,
  time,
  fees,
  dogName,
  openDate,
  level,
  closeDate,
  cutoffDate,
  premium,
  trialFile,
}) => {
  return (
    <>
      <p className="text-gray-900 font-sans text-xl font-semibold leading-7">
        {globalVariables.trialDetail}
      </p>
      <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6 lg:w-[500px] md:w-[300px] h-auto">
        <img src={hammer} alt="" />
        Judge: {name}
      </p>
      <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6 lg:w-[500px] md:w-[300px] h-auto ">
        <img src={barChart} alt="" />
        Levels: {filterUniqueLevels(level)?.map((search) => search?.level)?.join(", ")}
      </p>
      {/* <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6 lg:w-[500px] md:w-[300px] h-auto">
        <img src={clock} alt="" />
        Time: {time}
      </p> */}
      {console.log("Levels Here " , level , filterUniqueLevels(level))}
      {filterUniqueLevels(level)?.map((search) => {
        return (
          <p className="h-6 gap-1 flex md:w-[500px] text-gray-700 font-sans  font-medium  text-sm md:text-base ">
            <img src={currencyDollar} alt="" />
            {`${search?.level}  Entry Fees: $${search?.entryFee}`}
            <span className="text-[#98A2B3] font-sans text-[16px] font-[500] leading-6">
              ({dogName})
            </span>
          </p>
        );
      })}
      <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6 lg:w-[500px] md:w-[300px] h-auto">
        <img src={calendar} alt="" />
        Open Date: {openDate}
      </p>
      <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6 lg:w-[500px] md:w-[300px] h-auto">
        <img src={calendar} alt="" />
        Close Date: {closeDate}
      </p>
      {cutoffDate && (
        <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6 lg:w-[500px] md:w-[300px] h-auto">
          <img src={calendar} alt="" />
          Cutoff Date: {cutoffDate}
        </p>
      )}
     { trialFile &&  <a
        href={trialFile}
        target="_blank"
        rel="noreferrer"
        className="cursor-pointer"
      >
        <p className="h-6 gap-2 flex text-gray-700 font-sans text-[16px] font-[500] leading-6 lg:w-[500px] md:w-[300px] h-auto">
          <img src={star} alt="" /> {premium}
        </p>
      </a>}
    </>
  );
};
